<template>
  <div class="option-date">
    <van-nav-bar title="上课免打扰" :fixed="true" style="margin-bottom:15px;" left-text="返回" :border="false" left-arrow @click-left="backPage" />
    <div class="more-box">
      <div class="more-flex" v-for="(item,index) in dateList" :key="index" @click="checkThis(index)">
        <span :style="{color:(item.checkFlag && !item.isCheck)?'#666666':'#111111'}" class="more-span">{{item.text}}</span>
        <div :style="{display:item.isCheck?'flex':'none'}" class="check-istrator">
          <img class="check-img" src="@/assets/images/xuanzhong.png" background-size="cover" />
        </div>
      </div>
    </div>
    <div class="btn-box">
      <van-button round type="info" @click="save">保存</van-button>
    </div>
  </div>
</template>

<script>
import bus from '@/utils/lib/bus'
export default {
  data () {
    return {
      imei:'',//设备imei
      dateList:[],
      option:'',
      data:null,
    }
  },
  created () {
    this.option = this.$route.query.data?this.$route.query.data:''
    this.dateList = []
    this.data =JSON.parse(this.$store.state.noDisturbList);
    this.data.dayList.forEach((item,index) => {
        this.dateList.push({
            text:item,
            checkFlag:this.data.timeLengthArr[index]>=this.data.lengthNum,
            isCheck:this.option.day?this.option.day.includes(item):false
        })
    });
  },
  methods: {
    /**
    * 返回上一级
    */
    backPage() {
        this.$router.back(-1);
    },
    //选中
    checkThis(index){
      if(!this.dateList[index].isCheck && this.dateList[index].checkFlag) return
      this.dateList[index].isCheck = !this.dateList[index].isCheck
    },
    //保存
    save(){
        let a = {
            option:this.option,
            dateList:this.dateList
        }
        this.$store.commit('set_checkdata', JSON.stringify(a));
        // bus.$emit('checkDisturb',this.dateList)
        this.$router.back(-1);
    },
  }
}
</script>

<style scoped>
.option-date{
  background: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 100px 40px 0;
}
.more-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border-radius: 20px;
  margin-top: 25px;
}
.more-flex{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100px;
}
.more-span{
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: #111111;
  margin-left: 32px;
}
.check-istrator{
  margin-right: 40px;
}
.check-istrator .check-img{
  width: 40px;
  height: 40px;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding: 20px 0 50px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
</style>
<style lang="scss">
.option-date .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background: #01ADA9;
  color: #fff;
  border: 2px solid #01ADA9; 
}
.option-date{
    .van-nav-bar{
        background-color: #F8F8F8;
        width: 100%;
    }
}
</style>
